var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPitch = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .pitch-st0{fill:none;stroke:#FFFFFF;stroke-width:19.8692;stroke-linecap:round;stroke-miterlimit:10;}\n    .pitch-st1{fill:none;stroke:#FFFFFF;stroke-width:14.9019;stroke-linecap:round;stroke-miterlimit:10;}\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pitch"
  }, /*#__PURE__*/React.createElement("path", {
    className: "pitch-st0",
    d: "M222.7,147.9V253c0,18.4,14.9,33.3,33.3,33.3h0c18.4,0,33.3-14.9,33.3-33.3V147.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "pitch-st0",
    x1: 256,
    y1: 354.8,
    x2: 256,
    y2: 286.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "pitch-st0",
    cx: 256,
    cy: 354.8,
    r: 9.3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "lines"
  }, /*#__PURE__*/React.createElement("path", {
    id: "fullRight",
    className: "pitch-st1",
    d: "M333.7,239.7c5.6,3.2,9.4,9.3,9.4,16.3s-3.8,13.1-9.4,16.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "right",
    className: "pitch-st1",
    d: "M333.7,195.4c28.3,5.7,49.7,30.6,49.7,60.6s-21.4,54.9-49.7,60.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "left",
    className: "pitch-st1",
    d: "M178.3,272.3c-5.6-3.2-9.4-9.3-9.4-16.3s3.8-13.1,9.4-16.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fullLeft",
    className: "pitch-st1",
    d: "M178.3,316.6c-28.3-5.7-49.7-30.6-49.7-60.6s21.4-54.9,49.7-60.6"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPitch, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pitch.4440bc0d.svg";
export { ForwardRef as ReactComponent };